// noinspection ES6UnusedImports
import React, {useEffect, useRef, useState} from 'react';
import Landmark from '@core/scripts/components/landmark-adapter';
import {Select} from '@bonprix/design-system';

export default function ReviewSortFilter({filter, selectedFilters, text, onSort, texts, sorting, currentSelectedItem}) {

    const types = [
        {name: 'HELPFUL', text: texts?.ada12_review_filter_by_feedback, landmarkSuffix: 'helpful'},
        {name: 'NEWEST', text: texts?.ada12_review_filter_by_date, landmarkSuffix: 'new'},
        {name: 'BEST_RATING', text: texts?.ada12_review_filter_by_best_rating, landmarkSuffix: 'best'},
        {name: 'WORST_RATING', text: texts?.ada12_review_filter_by_worst_rating, landmarkSuffix: 'worst'}
    ];

    const onValueChange = (value) => {
        const type = types.find((aType) => aType.name === value);
        onSort?.({type: value, text: type.text});
        Landmark.sendClickLandmark('adp_reviews_sortby/' + currentSelectedItem?.itemNumber + '/' + type.landmarkSuffix);
    };

    return (
        <Select id={'sorting'} label={texts.ada12_review_sort_description} value={sorting?.type} onValueChange={onValueChange} >
            {types.map((type, index) => {
                return (
                    <Select.Item key={index} value={type.name} selected={type.name === sorting?.type}>{type.text}</Select.Item>
                );
            })}
        </Select>
    );

}
